// src/components/Footer.jsx
import React from "react";
import { FaTiktok } from "react-icons/fa";

export const Footer = (props) => {
  return (
    <footer id="footer">
      <div className="container text-center">
        <p className="slogan">"Simplificando tus importaciones, de principio a fin."</p>

        <div className="row footer-sections">
          <div className="col info">
            <h5>Horarios de Atención</h5>
            <p>Lunes a Viernes: 9:00 AM - 5:00 PM</p>
            <p>Sábados, domingos y feriados: Sin Atención </p>
          </div>

          <div className="col links">
            <h5>Enlaces Útiles</h5>
            <ul>
              <li><a href="/questions">Preguntas Frecuentes</a></li>
              <li><a href="/terms">Términos y Condiciones</a></li>
              <li><a href="/policies">Política de Privacidad</a></li>
            </ul>
          </div>

          <div className="col social">
            <h5>Síguenos</h5>
            <ul>
              <li>
                <a href={props.data?.facebook || "/"}>
                  <i className="fa fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href={props.data?.instagram || "/"}>
                  <i className="fa fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href={props.data?.tiktok || "/"}>
                  <i className="fa fa-tiktok"><FaTiktok /></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} ABX Shipping. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
